import { render, staticRenderFns } from "./SelectPlanDialog.vue?vue&type=template&id=2fb04004"
import script from "./SelectPlanDialog.vue?vue&type=script&lang=js"
export * from "./SelectPlanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports